import React from 'react'
import LoginLayout from '../../layouts/Login'
import LoginForm from '../../components/LoginForm'
import ImageLogin from '../../assets/ImageLogin.png'

const Login: React.FC = () => {
  return (
    <LoginLayout backgroundColor="#fff" imageSrc={ImageLogin}>
      <div>
        <LoginForm />
      </div>
    </LoginLayout>
  )
}

export default Login
